


import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import AuthService from "../../service/AuthService";
import appStyles from "../../styles/appStyles";
import { customStyles } from "../../styles/tableStyle";
import Disclaimer from "../other/Disclaimer";
import PolicyReminder from "../other/PolicyReminder";
import { appMessages } from "../../constants/appMessages";
import { AuthContext } from "../../AuthProvider";

;
const { Card, CardHeader, CardContent, CardActions, Button, LinearProgress, Divider,
  Typography, Box, RadioGroup, Radio, FormControlLabel, FormControl, InputLabel, Select, MenuItem,
  ToggleButtonGroup, ToggleButton,
  Icon } = require("@mui/material")


const { commons, util } = require("../../commons")
const { SnackBarWidget, DialogWidget } = require("../../Widget");


export default function UploadInputs(props) {

  const { setRegisterMapData, setType, actionType } = useContext(AuthContext);
  const [status, setStatus] = useState(false)
  const [message, setMessage] = useState('')
  const [apiService, setApiService] = useState(false)
  const [selectedImage, setSelectedImage] = useState(null)
  const [projectId, setProjectId] = useState("")
  const [selectedRadio, setSelectedRadio] = useState("")
  const [uploadErr, setUploadErr] = useState("")
  const [inputKey, setInputKey] = useState(0)
  const [showDialog, setShowDialog] = useState(false)
  const [action, setAction] = useState("")
  const [verilogType, setVerilogType] = useState("sv")
  const [policyDialog, setPolicyDialog] = useState(false)

  useEffect(() => {
    setType(props.type.toLowerCase())

  }, [])

  const loadDefaults = () => {
    setStatus(false)
    setMessage("")
  }

  const resetForm = async () => {
    setSelectedImage(null)
    setUploadErr("")
    setInputKey(0)
  };

  const uploadFile = async (e) => {
    const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel', 'application/xml', 'text/xml'];
    let uploadedFile = e.target.files[0];
    let uploadErrMsg = ""
    if (!uploadedFile)
      uploadErrMsg = 'Please select file.';

    else if (uploadedFile && !validTypes.includes(uploadedFile.type)) uploadErrMsg = 'Please select valid file.';

    else if (uploadedFile && uploadedFile.type === "") uploadErrMsg = 'Please select valid file.';

    if (uploadErrMsg.length)
      setUploadErr(uploadErrMsg)
    else {
      setSelectedImage(uploadedFile)
      setUploadErr('')
      setInputKey(1)
    }
  }

  const handleRadioChange = (event) => {
    setVerilogType(event.target.value)
  };
  const closeDialog = () => {
    setShowDialog(false)
  };

  const openDialog = () => {
    setShowDialog(true)
  };
  const validateFile = () => {

    const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel', 'application/xml', 'text/xml'];
    setUploadErr("")
    setShowDialog(false)

    if (!selectedImage) {
      setUploadErr('Please select file')
      return;
    }

    if (selectedImage && !validTypes.includes(selectedImage.type)) {
      setUploadErr('Please select valid file')
      return;
    }
    setAction(props.type.toLowerCase())
    if (props.type.toLowerCase() == "ral") setPolicyDialog(true)
    openDialog();

  }
  const displayPolicyDialog = () => {
    setPolicyDialog(true)
    openDialog()

  }

  const uploadRegisterFile = async () => {

    const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel', 'application/xml', 'text/xml'];
    setUploadErr("")
    setShowDialog(false)
    setPolicyDialog(false)
    let projectId = localStorage.getItem("projectId")

    if (!selectedImage) {
      setUploadErr('Please select file')
      return;
    }


    if (selectedImage && !validTypes.includes(selectedImage.type)) {
      setUploadErr('Please select valid file')
      return;
    }
    setApiService(true)
    let data = new FormData();
    data.append('projectId', projectId);
    data.append('file', selectedImage);
    data.append('type', props.type.toLowerCase())
    data.append('op', 'uploadFile')
    if (props.type.toLowerCase() == "rtl")
      data.append('verilogType', verilogType)
    try {
      commons.getAPIRes(data, "POSTFORMDATA", "fileOp").then(res => {
        setApiService(false)
        if (res.logs)
          localStorage.setItem("newLogs", res.logs)

        props.loadLogs()

        if (!res.status) {
          setMessage(props.type + appMessages.uploadFailMsg)
          setStatus(false)

          setTimeout(function () {
            loadDefaults()
          }.bind(this), 2000)
        }
        if (res.status) {
          setMessage(res.message ? res.message : props.type + appMessages.uploadSucMsg)
          setStatus(true)
          if (res.result.registerData) {
            // localStorage.setItem("type", props.type.toLowerCase())
            setRegisterMapData(projectId + "_" + props.type.toLowerCase(), res.result.registerData)

          }
          const zipContent = atob(res.result.zipFile);
          const zipBlob = new Blob([Uint8Array.from(zipContent, c => c.charCodeAt(0))], { type: 'application/zip' });
          const url = window.URL.createObjectURL(zipBlob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'files.zip');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    } catch (error) {
      console.error('There was an error downloading the zip file!', error);
    }



  };



  return (
    <Box sx={{ alignContent: 'center', width: '96%' }}>
      {commons.detectInternet()}
      <Card style={{ margin: "10px" }} variant="outlined" sx={{
        bgcolor: 'background.paper',
        boxShadow: 1,
        borderRadius: 2,
        p: 2,
        width: '100%',
        // minWidth: 300,
        height: '70%',
        alignContent: 'center',
      }}>

        <CardContent style={{
          display: 'flex', flexDirection: 'column', justifyContent: 'space-between'
        }}>
          {apiService ? <LinearProgress /> : false}

          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="caption">Upload IPXACT / Register file &nbsp;</Typography>
            <FormControl fullWidth style={{ flex: 2 }}>
              <input
                type="file"
                name="myImage"
                onChange={(e) => uploadFile(e)}
              /> </FormControl>
          </div>
          <br />
          {uploadErr.length ?
            <div style={{ display: 'flex', padding: 1 }}>
              <Typography color="error" variant="subtitle">
                {uploadErr}
              </Typography> </div> : false}
        </CardContent>

        <CardActions style={{ justifyContent: "center" }} >

          <Button variant="contained" color="primary"
            style={customStyles.successBtn}
            size="small"
            onClick={e => validateFile(e)}
          >
            Upload
          </Button>
        </CardActions>

        <Disclaimer style={{ justifyContent: 'bottom' }} />
      </Card>

      {showDialog && action == "rtl" ? (
        <DialogWidget
          maxWidth={"md"}
          dialogTitle={"Verilog Type"}
          dialogContent={
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              value={verilogType}
              name="radio-buttons-group"
              style={{ flexDirection: 'row' }}
              onChange={(e) => handleRadioChange(e)}
            >
              <FormControlLabel value={"sv"} control={<Radio />} label="System Verilog" />
              <FormControlLabel value={"v"} control={<Radio />} label="Verilog" />
            </RadioGroup>
          }
          okDialog={displayPolicyDialog}
          closeDialog={closeDialog}
          okTitle={"Continue"}
          negCancel={true}

        />
      ) : (
        false
      )}
      {showDialog && policyDialog ? (
        <DialogWidget
          maxWidth={"md"}
          dialogTitle={"Reminder"}
          dialogContent={
            <PolicyReminder

            />
          }
          okDialog={uploadRegisterFile}
          closeDialog={closeDialog}
          negCancel={true}
          okTitle={"Continue"}

        />
      ) : (
        false
      )}


      <SnackBarWidget message={message} status={status} />
    </Box>
  );

}


